export default function heapTrackEvent(eventName) {
  if (typeof window !== 'undefined' && window.heap) {
    window.heap.track(eventName);
  }
}



// WEBPACK FOOTER //
// ./src/utils/heapTrackEvent.js